import { Injectable } from '@angular/core';
import { WindowService } from '@cigna/core/window';
import {
  IconDynamicColors,
  IconDynamicData,
  OmniAnalyticsService,
} from '@cigna/omni/shared';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { BubbleClick, LaunchChat } from './chat-bubble.actions';
import {
  getChatBubbleData,
  getIconColors,
  showChatBubble,
} from './chat-bubble.selectors';
import { ScreenSize } from '@cigna/ui/responsive';
import { FeatureTogglesFacade } from '@cigna/features';
import { take } from 'rxjs/operators';
@Injectable()
export class ChatBubbleFacade {
  public chatBubbleData$: Observable<
    Record<ScreenSize.XSmall | ScreenSize.Medium, IconDynamicData>
  > = this.store$.pipe(select(getChatBubbleData));
  public iconColors$: Observable<IconDynamicColors> = this.store$.pipe(
    select(getIconColors),
  );
  public showChatBubble$: Observable<boolean> = this.store$.pipe(
    select(showChatBubble(this._window)),
  );
  isEvernorth: boolean;
  canUpdateAnalyticsData: boolean;

  constructor(
    private analytics: OmniAnalyticsService,
    private store$: Store<any>,
    private _window: WindowService,
    private featureToggleFacade: FeatureTogglesFacade,
  ) {
    this.featureToggleFacade
      .featuresEnabled(['isEvernorthEnabled'])
      .pipe(take(2))
      .subscribe((isEvm) => {
        this.isEvernorth = isEvm;
      });
    this.featureToggleFacade
      .featuresEnabled(['canUpdateAnalyticsData'])
      .pipe(take(2))
      .subscribe((canUpdateAnalyticsData) => {
        this.canUpdateAnalyticsData = canUpdateAnalyticsData;
      });
  }

  public chatBubbleClick(text: string): void {
    if (!this.canUpdateAnalyticsData) {
      if (this.isEvernorth) {
        this.analytics.trackEvent('chatBubbleClickOnEvm', { bubbleText: text });
      } else {
        this.analytics.trackEvent('chatBubbleClick', { bubbleText: text });
      }
    }

    this.store$.dispatch(new BubbleClick());
  }

  public launchChat(text: string) {
    this.store$.dispatch(new LaunchChat(text));
  }
}
